export const colors = {
  white: '#FFFFFF',
  black: '#273138',
  gray: '#E6E8EC',
  gray1: '#D4DCE7',
  gray2: '#6B747A',
  gray3: '#F6F7F8',
  gray4: '#A1ABB1',
  gray5: '#EBEDEF',
  gray6: '#F4F4F6',
  gray7: '#C0C4DA',
  gray8: '#EFEFEF',
  gray9: '#F6F6FB',
  gray10: '#F7F7F7',
  gray11: '#BABABA',
  gray12: '#72768B',
  gray13: '#EBEBEB',
  gray14: '#DBDBDB',
  gray15: '#FAFAFA',
  gray16: '#E2E3E5',
  gray17: '#DADBDD',
  gray18: '#B6BABE',
  slate: '#9EA2BD',
  yellow: '#FFC554',
  orange: '#FFA621',
  orange2: '#FF8B42',
  lightOrange: '#FFECD0',
  lightOrange2: '#FDF5E5',
  red: '#FF655B',
  red2: '#D84446',
  lightRed: '#FFDCDA',
  lightRed2: '#FEE6E5',
  lightTurqoise: '#E3FFF5',
  lightTurqoise2: '#E0FCF2',
  green: '#42CB9A',
  lightGreen: '#EBFFD8',
  darkGreen: '#097B06',
  blue: '#4992FF',
  blue2: '#AED0DF',
  blue3: '#2A96D6',
  blue4: '#2FA3FF',
  blue5: '#0066B7',
  blue6: '#288BD9',
  blue7: '#4494F9',
  lightBlue: '#E0F5FE',
  lightBlue2: '#D4E5FF',
  lightBlue3: '#EEF0FC',
  lightBlue4: '#DFF5FD',
  lightBlue5: '#E6F2FF',
  lightBlue6: '#F5FAFF',
  purple: '#B598CA',
  lightPurple: '#E6E7FD',
  pink: '#FC9EFA',
  magenta: '#FF20B8',
  magentaOpacity5: '#FF20B80D',
  lightMagenta: '#FFF4FB',
  blackOpacity5: '#2731380D',
  lightPink: '#FEF0FE',
  red10: '#FEF1F0',
  red100: '#F0756D',
  orange10: '#FEF5E5',
  orange100: '#F59F00',
  attentionYellow: '#FFF9BF',
  green10: '#EBF8F3',
  green100: '#33B989',
  green200: '#D9F2E8',
  jetGrey: '#5e638b',
  lightGrey: '#6747A',
};

export const extendedColors = {
  aiGradientPink: '#f9c4ff',
  aiGradientRose: '#fbc2eb',
  aiGradientBlue: '#a1c4fd',
  avatarPurple: '#A752CF',
  avatarRed: '#DA0B0B',
  avatarBlue: '#0B90DA',
  avatarGreen: '#24B221',
  avatarYellow: '#ECB22E',
  avatarOrange: '#D98C19',
  avatarMagenta: '#D0038D',
  seriesPlum: '#4A165C',
  seriesRose: '#F53770',
  seriesRed: '#FF4D4F',
  seriesOrange: '#FF7A45',
  seriesTeal: '#2AAC9D',
  seriesTurquoise: '#36D7C3',
  seriesAqua: '#41F3DE',
  seriesGreen: '#089C55',
  seriesLime: '#73D13D',
  seriesYellow: '#D2F20A',
  seriesBlue: '#096DD9',
  seriesSky: '#6FB6E1',
  seriesNavy: '#252D7A',
  seriesViolet: '#9A4FEB',
  seriesLavender: '#D2BFFB',
  githubInk: '#24292e',
  gitlabOrange: '#fc6d26',
  bitbucketBlue: '#0052cc',
  azureBlue: '#1976d2',
  editorBg: '#f2f2f2',
  editorGutterBg: '#e0e0e0',
  editorGutterText: '#a0a0a0',
  neutral240: '#f0f0f0',
  neutral235: '#e9eaeb',
  neutral248: '#F8F8F8',
  neutral238: '#EBEEF0',
  neutral254: '#fefcfc',
  lightBlueAlice: '#f0f8ff',
  pureBlack: '#000',
  pureWhite: '#fff',
  scrollbarThumb: '#D4D4D4',
  slateGray: '#98A2B3',
};

export const translucentColors = {
  black87: 'rgba(0, 0, 0, 0.87)',
  black60: 'rgba(0, 0, 0, 0.6)',
  black54: 'rgba(0, 0, 0, 0.54)',
  black38: 'rgba(0, 0, 0, 0.38)',
  black26: 'rgba(0, 0, 0, 0.26)',
  black12: 'rgba(0, 0, 0, 0.12)',
  black10: 'rgba(0, 0, 0, 0.1)',
  black08: 'rgba(0, 0, 0, 0.08)',
  black04: 'rgba(0, 0, 0, 0.04)',
  black50: 'rgba(0, 0, 0, 0.5)',
  black40: 'rgba(0, 0, 0, 0.4)',
  black25: 'rgba(0, 0, 0, 0.25)',
  black20: 'rgba(0, 0, 0, 0.2)',
  black05: 'rgba(0, 0, 0, 0.05)',
  black03: 'rgba(0, 0, 0, 0.03)',
  white90: 'rgba(255, 255, 255, 0.9)',
  white60: 'rgba(255, 255, 255, 0.6)',
  gray161At40: 'rgba(161, 161, 161, 0.4)',
  gray200At30: 'rgba(200, 200, 200, 0.3)',
  gray221At34: 'rgba(221, 221, 221, 0.34)',
  lavenderAt50: 'rgba(230, 230, 240, 0.5)',
  inkBlueAt13: 'rgba(58, 65, 103, 0.13)',
  aliceBlueAt90: 'rgba(240, 247, 255, 0.9)',
  ink50: 'rgba(39, 49, 56, 0.5)',
};

export const materialColors = {
  white: '#fff',
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
};

export const fontStacks = {
  geist: "'Geist', sans-serif",
  geistFace: "'Geist'",
  geistMono: "'Geist Mono', monospace",
};
